// store/slices/instantServiceSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  service: null,
  isLoading: false,
  error: null,
  activityLogged: false,
};

const instantServiceSlice = createSlice({
  name: "instantService",
  initialState,
  reducers: {
    fetchInstantServiceDetailRequest: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    fetchInstantServiceDetailSuccess: (state, action) => {
      state.isLoading = false;
      state.service = action.payload;
      state.error = null;
    },
    fetchInstantServiceDetailFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    logInstantServiceActivityRequest: (state, action) => {
      state.activityLogged = false;
    },
    logInstantServiceActivitySuccess: (state, action) => {
      state.activityLogged = true;
    },
    logInstantServiceActivityFailure: (state, action) => {
      console.error("Activity logging failed:", action.payload);
    },
    clearInstantServiceDetail: (state) => {
      state.service = null;
      state.error = null;
      state.isLoading = false;
      state.activityLogged = false;
    },
  },
});

export const {
  fetchInstantServiceDetailRequest,
  fetchInstantServiceDetailSuccess,
  fetchInstantServiceDetailFailure,
  logInstantServiceActivityRequest,
  logInstantServiceActivitySuccess,
  logInstantServiceActivityFailure,
  clearInstantServiceDetail,
} = instantServiceSlice.actions;

export default instantServiceSlice.reducer;
